<section class="page-section" id="login">
  <div class="extra-background">
    <div class="container">
      <div class="row">
        <div class="col-lg-12 text-center">
          <h2 class="section-heading text-uppercase">Resume</h2>
        </div>
      </div>
      <mat-horizontal-stepper>
        <mat-step [stepControl]="personalDetailsForm">
          <form [formGroup]="personalDetailsForm">
            <ng-template matStepLabel>PERSONAL DETAILS</ng-template>
            <div class="row">
              <div class="col-md-6">
                <mat-form-field appearance='outline'>
                  <mat-label>Name</mat-label>
                  <input matInput placeholder="enter name...." formControlName="name" name="name" />
                </mat-form-field>
              </div>
              <div class="col-md-6">
                <mat-form-field appearance='outline'>
                  <mat-label>Surname</mat-label>
                  <input matInput placeholder="enter surname...." formControlName="surname" name="surname" />
                </mat-form-field>
              </div>
              <div class="col-md-6">
                <mat-form-field appearance='outline'>
                  <mat-label>Known As</mat-label>
                  <input matInput placeholder="enter Nicname...." formControlName="knownAs" name="knownAs" />
                </mat-form-field>
              </div>
              <div class="col-md-6">
                <mat-form-field appearance='outline'>
                  <mat-label>Gender</mat-label>
                  <mat-select placeholder="select gender...." formControlName="gender" name="gender">
                    <mat-option value="female">Female</mat-option>
                    <mat-option value="male">Male</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="col-md-6">
                <mat-form-field appearance='outline'>
                  <mat-label>Identity Number</mat-label>
                  <input matInput placeholder="enter identity number...." formControlName="identity" name="identity" />
                </mat-form-field>
              </div>
              <div class="col-md-6">
                <mat-form-field appearance='outline'>
                  <mat-label>Age</mat-label>
                  <input matInput placeholder="enter age...." formControlName="age" name="age" type="number" min="0" />
                </mat-form-field>
              </div>
              <div class="col-md-6">
                <mat-form-field appearance='outline'>
                  <mat-label>Nationality</mat-label>
                  <input matInput placeholder="enter nationality...." formControlName="nationality"
                    name="nationality" />
                </mat-form-field>
              </div>
              <div class="col-md-6">
                <mat-form-field appearance='outline'>
                  <mat-label>Ethnic/ race</mat-label>
                  <mat-select placeholder="select Ethnic/ Race...." formControlName="ethnicity" name="ethnicity">
                    <mat-option value="african">African</mat-option>
                    <mat-option value="asian">Asian</mat-option>
                    <mat-option value="Coloured">Coloured</mat-option>
                    <mat-option value="white">White</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="col-md-6">
                <mat-form-field appearance='outline'>
                  <mat-label>Telephone Number</mat-label>
                  <input matInput placeholder="enter Telephone Number...." formControlName="telephone"
                    name="telephone" />
                </mat-form-field>
                <mat-form-field appearance='outline'>
                  <mat-label>Email Address</mat-label>
                  <input matInput placeholder="enter Email...." formControlName="email" name="email" type="email" />
                </mat-form-field>
              </div>
              <div class="col-md-6">
                <mat-form-field appearance='outline'>
                  <mat-label>Residential Address</mat-label>
                  <textarea matInput rows="6" placeholder="enter Residential Address...."
                    formControlName="residentialAddress" name="residentialAddress"></textarea>
                </mat-form-field>
              </div>
              <div class="col-md-6">
                <mat-form-field appearance='outline'>
                  <mat-label>Marital Status</mat-label>
                  <mat-select formControlName="maritalStatus" name="maritalStatus">
                    <mat-option value="Single">Single</mat-option>
                    <mat-option value="Married">Married</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="col-md-6">
                <mat-form-field appearance='outline'>
                  <mat-label>Number of dependants</mat-label>
                  <input matInput placeholder="Enter number of dependants...." formControlName="dependants"
                    name="dependants" type="number" min="0" />
                </mat-form-field>
              </div>
              <div class="col-md-6">
                <mat-form-field appearance='outline'>
                  <mat-label>Drivers Licence</mat-label>
                  <mat-select formControlName="driversLicence" name="driversLicence">
                    <mat-option value="none">None</mat-option>
                    <mat-option value="C1">C1</mat-option>
                    <mat-option value="C">C</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="col-md-6">
                <mat-form-field appearance='outline'>
                  <mat-label>Own Transport</mat-label>
                  <input matInput placeholder="Enter own transport...." formControlName="ownTransport"
                    name="ownTransport" />
                </mat-form-field>
              </div>
              <div class="col-12 text-white language-table">
                <div class="row header-row">
                  <div class="header-col col-6 align-middle">
                    <h5>Language Proficiency</h5>
                  </div>
                  <div class="header-col col-2 align-middle text-center">
                    <h5>
                      <i class="fa fa-edit mx-2"></i>
                      <span class="d-none d-lg-inline">Speak</span>
                    </h5>
                  </div>
                  <div class="header-col col-2 align-middle text-center">
                    <h5>
                      <i class="fa fa-book mx-2"></i>
                      <span class="d-none d-lg-inline">Read</span>
                    </h5>
                  </div>
                  <div class="header-col col-2 align-middle text-center">
                    <h5>
                      <i class="fa fa-edit mx-2"></i>
                      <span class="d-none d-lg-inline">Write</span>
                    </h5>
                  </div>
                </div>
                <div *ngFor="let lang of languages;let i = index" class="row pt-4" [formGroup]="lang">
                  <div class="col-6">
                    <h5>{{lang.controls.languageName.value}}</h5>
                  </div>
                  <div class="col-2 text-center">
                    <mat-checkbox class="example-margin" formControlName="speak" name="speak"></mat-checkbox>
                  </div>
                  <div class="col-2 text-center">
                    <mat-checkbox class="example-margin" formControlName="read" name="read"></mat-checkbox>
                  </div>
                  <div class="col-2 text-center">
                    <mat-checkbox class="example-margin" formControlName="write" name="write"></mat-checkbox>
                  </div>
                </div>
                <div *ngFor="let lang of otherLanguages;let i = index" class="row" [formGroup]="lang">
                  <div class="col-6">
                    <mat-form-field appearance='outline'>
                      <mat-label></mat-label>
                      <input matInput placeholder="Enter own transport...." formControlName="languageName"
                        name="languageName" (change)="removeLanguage(i)" />
                    </mat-form-field>
                  </div>
                  <div class="col-2 text-center pt-4">
                    <mat-checkbox class="example-margin" formControlName="speak" name="speak"></mat-checkbox>
                  </div>
                  <div class="col-2 text-center pt-4">
                    <mat-checkbox class="example-margin" formControlName="read" name="read"></mat-checkbox>
                  </div>
                  <div class="col-2 text-center pt-4">
                    <mat-checkbox class="example-margin" formControlName="write" name="write"></mat-checkbox>
                  </div>
                </div>
                <div class="row">
                  <div class="col-6">
                    <mat-form-field appearance='outline'>
                      <mat-label>other language</mat-label>
                      <input matInput placeholder="Enter language...." formControlName="language" name="language"
                        (change)="addLanguage()" />
                    </mat-form-field>
                  </div>
                </div>
              </div>
            </div>

            <div class="mt-4">
              <button class="btn btn-fsp" matStepperNext>Next</button>
            </div>
          </form>
        </mat-step>
        <mat-step [stepControl]="qualifactionsForm">
          <form [formGroup]="qualifactionsForm">
            <ng-template matStepLabel>Qualifcations</ng-template>
            <div [formGroup]="this.qualifactionsForm.controls.school.value">
              <h3 class="text-white">School Qualifaction</h3>
              <div class="row">
                <div class="col-md-6">
                  <mat-form-field appearance='outline'>
                    <mat-label>Name of institution</mat-label>
                    <input matInput placeholder="enter name...." formControlName="name" name="name" />
                  </mat-form-field>
                </div>
                <div class="col-md-6">
                  <mat-form-field appearance='outline'>
                    <mat-label>Highest Grade Passed</mat-label>
                    <mat-select placeholder="select grade...." formControlName="grade" name="grade">
                      <mat-option value="1">Grade 1</mat-option>
                      <mat-option value="2">Grade 2</mat-option>
                      <mat-option value="3">Grade 3</mat-option>
                      <mat-option value="4">Grade 4</mat-option>
                      <mat-option value="5">Grade 5</mat-option>
                      <mat-option value="6">Grade 6</mat-option>
                      <mat-option value="7">Grade 7</mat-option>
                      <mat-option value="8">Grade 8</mat-option>
                      <mat-option value="9">Grade 9</mat-option>
                      <mat-option value="10">Grade 10</mat-option>
                      <mat-option value="11">Grade 11</mat-option>
                      <mat-option value="12">Grade 12</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div class="col-md-6">
                  <mat-form-field appearance='outline'>
                    <mat-label>Year Completed</mat-label>
                    <input matInput placeholder="enter Year Completed...." formControlName="year" name="year" />
                  </mat-form-field>
                </div>
              </div>
            </div>
            <div>
              <h3 class="text-white">Tertiary Qualifaction <button class="btn btn-fsp mx-3 bold" type="button"
                  (click)="addQualification()">+</button></h3>
              <div *ngFor="let item of this.qualifactionsForm.controls.tertiary.value.controls;let i = index ">
                <div class="row" [formGroup]="item">
                  <div class="col-md-6">
                    <mat-form-field appearance='outline'>
                      <mat-label>Name of institution</mat-label>
                      <input matInput placeholder="enter Nicname...." formControlName="instituteName"
                        name="instituteName" />
                    </mat-form-field>
                  </div>
                  <div class="col-md-6">
                    <mat-form-field appearance='outline'>
                      <mat-label>Qualifaction Name</mat-label>
                      <input matInput placeholder="enter Nicname...." formControlName="qualifactionName"
                        name="qualifactionName" />
                    </mat-form-field>
                  </div>
                  <div class="col-md-6">
                    <mat-form-field appearance='outline'>
                      <mat-label>Qualification Type</mat-label>
                      <mat-select placeholder="select gender...." formControlName="qualifactionType"
                        name="qualifactionType">
                        <mat-option value="National Diploma">National Diploma</mat-option>
                        <mat-option value="Bachelors Degree">Bachelors Degree</mat-option>
                        <mat-option value="Honours Degree">Honours Degree</mat-option>
                        <mat-option value="Masters Degree">Masters Degree</mat-option>
                        <mat-option value="Doctrate Degree">Doctrate Degree</mat-option>
                        <mat-option value="Other">Other</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="col-md-6">
                    <mat-form-field appearance='outline'>
                      <mat-label>Year completed</mat-label>
                      <input matInput placeholder="enter identity number...." formControlName="QualifactionYear"
                        name="QualifactionYear" />
                    </mat-form-field>
                  </div>
                </div>
                <div class="text-right">
                  <button class="btn btn-danger" (click)="removeQualification(i)" type="button">X</button>
                </div>
                <hr *ngIf="i < this.qualifactionsForm.controls.tertiary.value.controls.length - 1" />
              </div>

            </div>
            <div>
              <h3 class="text-white">Skills</h3>
              <div *ngFor="let item of this.qualifactionsForm.controls.skills.value.controls;let i = index ">
                <div class="row" [formGroup]="item">
                  <div class="col-md-6">
                    <mat-form-field appearance='outline'>
                      <mat-label>skill description</mat-label>
                      <input matInput placeholder="enter Nicname...." formControlName="skillDescription"
                        name="skillDescription" (change)="removeSkill(i)" />
                    </mat-form-field>
                  </div>
                </div>
              </div>
              <div>
                <div class="row">
                  <div class="col-md-6">
                    <mat-form-field appearance='outline'>
                      <mat-label>skill description</mat-label>
                      <input matInput placeholder="enter skill description...." formControlName="newSkill"
                        name="newSkill" (change)="addSkill()" />
                    </mat-form-field>
                  </div>
                </div>
              </div>
            </div>

            <div class="mt-4">
              <button class="btn btn-fsp mx-2" matStepperPrevious>Previous</button>
              <button class="btn btn-fsp mx-2" matStepperNext>Next</button>
            </div>
          </form>
        </mat-step>

        <mat-step [stepControl]="experienceForm">
          <form [formGroup]="experienceForm">
            <ng-template matStepLabel>Experience</ng-template>
            <div>
              <h3 class="text-white">Work Experience <button class="btn btn-fsp mx-3 bold" type="button"
                  (click)="addExperience()">+</button></h3>
              <div *ngFor="let item of this.experienceForm.controls.workExperience.value.controls;let i = index "
                [formGroup]="item">
                <div class="row">
                  <div class="col-md-6">
                    <mat-form-field appearance='outline'>
                      <mat-label>Name of company</mat-label>
                      <input matInput placeholder="enter Nicname...." formControlName="companyName"
                        name="companyName" />
                    </mat-form-field>
                  </div>
                  <div class="col-md-6">
                    <mat-form-field appearance='outline'>
                      <mat-label>type of Componany</mat-label>
                      <input matInput placeholder="enter Nicname...." formControlName="companyType"
                        name="companyType" />
                    </mat-form-field>
                  </div>
                  <div class="col-md-6">
                    <mat-form-field appearance='outline'>
                      <mat-label>City/Town</mat-label>
                      <input matInput placeholder="enter Nicname...." formControlName="companyLocation"
                        name="companyLocation" />
                    </mat-form-field>
                  </div>
                  <div class="col-md-6">
                    <mat-form-field appearance='outline'>
                      <mat-label>Position Held</mat-label>
                      <input matInput placeholder="enter Nicname...." formControlName="positionHeld"
                        name="positionHeld" />
                    </mat-form-field>
                  </div>
                  <div class="col-md-6">
                    <mat-form-field appearance='outline'>
                      <mat-label>Employed From</mat-label>
                      <input matInput placeholder="enter Nicname...." formControlName="employedFrom" name="employedFrom"
                        type="date" />
                    </mat-form-field>
                  </div>
                  <div class="col-md-6">
                    <mat-form-field appearance='outline'>
                      <mat-label>Employed to</mat-label>
                      <input matInput placeholder="enter Nicname...." formControlName="employedTo" name="employedTo"
                        type="date" />
                    </mat-form-field>
                  </div>
                  <div class="col-md-6 text-white">
                    <mat-checkbox formControlName="currentEmployer" name="currentEmployer">Current Employer
                    </mat-checkbox>
                  </div>
                </div>
                <div>
                  <h3 class="text-white">Duties / Functions</h3>
                  <div *ngFor="let duty of item.controls.duties.value.controls;let ii = index ">
                    <div class="row" [formGroup]="duty">
                      <div class="col-md-6">
                        <mat-form-field appearance='outline'>
                          <mat-label>skill description</mat-label>
                          <input matInput placeholder="enter Nicname...." formControlName="duty" name="duty"
                            (change)="removeDuty(i,ii)" />
                        </mat-form-field>
                      </div>
                    </div>
                  </div>
                  <div>
                    <div class="row">
                      <div class="col-md-6">
                        <mat-form-field appearance='outline'>
                          <mat-label>skill description</mat-label>
                          <input matInput placeholder="enter skill description...." formControlName="newDuty"
                            name="newDuty" (change)="addDuty(i)" />
                        </mat-form-field>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="text-right">
                  <button class="btn btn-danger" (click)="removeExperience(i)" type="button">X</button>
                </div>
                <hr *ngIf="i < this.qualifactionsForm.controls.tertiary.value.controls.length - 1" />
              </div>

            </div>

            <div class="mt-4">
              <button class="btn btn-fsp mx-2" matStepperPrevious>Previous</button>
              <button class="btn btn-fsp mx-2" matStepperNext>Next</button>
            </div>
          </form>
        </mat-step>
        <mat-step [stepControl]="referenceForm">
          <form [formGroup]="referenceForm">
            <ng-template matStepLabel>Reference</ng-template>
            <div>
              <h3 class="text-white">Work References <button class="btn btn-fsp mx-3 bold" type="button"
                  (click)="addReference()">+</button></h3>
              <div *ngFor="let item of this.referenceForm.controls.references.value.controls;let i = index "
                [formGroup]="item">
                <div class="row">
                  <div class="col-md-6">
                    <mat-form-field appearance='outline'>
                      <mat-label>Name of company</mat-label>
                      <input matInput placeholder="enter Nicname...." formControlName="companyName"
                        name="companyName" />
                    </mat-form-field>
                  </div>
                  <div class="col-md-6">
                    <mat-form-field appearance='outline'>
                      <mat-label>Referee Name</mat-label>
                      <input matInput placeholder="enter Nicname...." formControlName="RefereeName"
                        name="RefereeName" />
                    </mat-form-field>
                  </div>
                  <div class="col-md-6">
                    <mat-form-field appearance='outline'>
                      <mat-label>Referee</mat-label>
                      <input matInput placeholder="enter Nicname...." formControlName="RefereePosition"
                        name="RefereePosition" />
                    </mat-form-field>
                  </div>
                  <div class="col-md-6">
                    <mat-form-field appearance='outline'>
                      <mat-label>Telephone Number</mat-label>
                      <input matInput placeholder="enter Nicname...." formControlName="telephoneNumber"
                        name="telephoneNumber" />
                    </mat-form-field>
                  </div>
                </div>

                <div class="text-right">
                  <button class="btn btn-danger" (click)="removeReference(i)" type="button">X</button>
                </div>
                <hr *ngIf="i < this.qualifactionsForm.controls.tertiary.value.controls.length - 1" />
              </div>

            </div>

            <div class="mt-4">
              <button class="btn btn-fsp mx-2" matStepperPrevious>Previous</button>
              <button class="btn btn-fsp mx-2"type="button" (click)="saveResume()" >Save</button>
            </div>
          </form>
        </mat-step>
      </mat-horizontal-stepper>
    </div>
  </div>
</section>
